import { RequestMutationOptions } from '@approvalmax/data';
import { useMutate } from 'shared/data/api';

import { tokenApiPaths } from '../paths';
import { CreateExternalPersonImage } from './useCreateExternalPersonImage.types';

export const useCreateExternalPersonImage = (
    mutationOptions: RequestMutationOptions<CreateExternalPersonImage>,
    options: { accessToken: string }
) =>
    useMutate(tokenApiPaths.images, {
        mutationOptions,
        formData: true,
        apiSource: 'walletsKyc',
        apiVersion: 'v1',
        ...options,
    });
